import VerifyToken from '@/modules/verify-token/views/VerifyToken.vue'

export default {
  path: '/verify-token/authenticate/:expires_in/:redirect_route_name?/:redirect_params_base64?',
  name: 'verify-token-authenticate',
  component: VerifyToken,
}

